import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../layout/Header";
import {
  trackIntercomEvent,
  updateIntercomUser,
} from "../../../../util/intercom";

const UnifiedOrhtocheck = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [iframeUrl, setIframeUrl] = useState("");

  const queryParams = new URLSearchParams(location.search);
  const apikey = queryParams.get("key") || process.env.REACT_APP_X_API_KEY;
  const path = queryParams.get("path") || "";
  const telehealthAppointment = queryParams.get("telehealth") || "false";
  const client = queryParams.get("client") || "mop";
  const recommended = queryParams.get("recommended") || true;
  const origin =
    queryParams.get("origin") || process.env.REACT_APP_PARENT_ORIGIN;

  const handleIframeMessage = (event) => {
    // Make sure message is from trusted domain
    if (event.origin !== process.env.REACT_APP_UNIFIED_ORTHOCHECK_URL) return;

    if (event.data.type === "IFRAME_NAVIGATION") {
      const url = new URL(window.location.href);
      url.searchParams.set("path", event.data.path);
      url.searchParams.set("key", event.data.key);
      url.searchParams.set("client", event.data.client);
      url.searchParams.set("recommended", event.data.recommended);
      url.searchParams.set("origin", event.data.origin);

      window.history.pushState({}, "", url.toString());
    }
  };

  useEffect(() => {
    window.addEventListener("message", handleIframeMessage);

    return () => {
      window.removeEventListener("message", handleIframeMessage);
    };
  }, []);

  useEffect(() => {
    const url = new URL(
      `${process.env.REACT_APP_UNIFIED_ORTHOCHECK_URL}${path}?key=${apikey}&client=${client}&recommended=${recommended}&origin=${origin}&telehealth_appointment=${telehealthAppointment}`
    );
    setIframeUrl(url);
  }, [path, apikey, client, recommended, origin, telehealthAppointment]);

  useEffect(() => {
    const handleMessage = (event) => {
      // ✅ only trust messages from the iframe’s domain
      if (
        event.origin !== new URL(process.env.REACT_APP_PARENT_ORIGIN).origin
      ) {
        return;
      }

      if (event.data.type === "NAVIGATE") {
        const newPath = event.data.path;
        navigate(`/orthocheck/unified?path=${newPath}&key=${apikey}`);
      }

      if (event.data.type === "INTERCOM_EVENT") {
        console.log(
          "Intercom event received:",
          event.data.eventName,
          event.data.data
        );

        if (event.data.eventName === "updateIntercomUser") {
          updateIntercomUser(event.data.data);
        } else {
          trackIntercomEvent(event.data.eventName, event.data.data);
        }
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [navigate, apikey]);

  return (
    <div
      style={{ display: "flex", flexDirection: "column", height: "inherit" }}
    >
      <Header />
      <div
        style={{
          flex: 1,
          width: "100%",
          overflow: "hidden",
        }}
      >
        <iframe
          src={iframeUrl}
          style={{
            width: "100%",
            height: "100%",
            border: "none",
          }}
          allow="geolocation"
          frameBorder="0"
          scrolling="yes"
          title="Orthocheck"
        />
      </div>
    </div>
  );
};

export default UnifiedOrhtocheck;
